

import { coreAxios } from "@/declare/api/axios"
import { Region } from "@/declare/interface/project/region"
import { AxiosResponse } from "axios"

/**
 * 添加区域
 * @param data
 * @returns
 */
export function createRegion(projectUuid: string, data: Region, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/projects/${projectUuid}/regions`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取区域
 * @returns
 */
export function findRegions(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/projects/${projectUuid}/regions`, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改区域
 */
export function updateRegion(regionUuid: string, data: Region, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/regions/${regionUuid}`, data, {
        params: {
            ...params,
        }
    })
}

/**
 * 删除区域
 */
export function deleteRegion(regionUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/regions/${regionUuid}`, {
        params: {
            ...params,
        }
    })
}